let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hHYgX")).then(() => parcelRequire('7t6Ue'));